// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { skaleBlockBrawlers as _skaleBlockBrawlers } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the skaleBlockBrawlers chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 391845894
 * Chain Name: SKALE | Block Brawlers
 * Default Block Explorer: https://frayed-decent-antares.explorer.mainnet.skalenodes.com
 * Default RPC URL: https://mainnet.skalenodes.com/v1/frayed-decent-antares
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { skaleBlockBrawlers } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: skaleBlockBrawlers,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const skaleBlockBrawlers = createCommon({
	..._skaleBlockBrawlers,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
